import PropTypes from 'prop-types'
import useFeatureToggle from '@/hooks/useFeatureToggle'
import { FeatureToggle } from '@/resources/enums/featureToggle'
import { STORE_AVAILABILITY_POLLING_TIME } from '@/seller.application.polling.time.config'
import HexaV2SideBarMenu from '../HexaV2SidebarMenu'
import SideBarMenu from '../SidebarMenu'
import StoreAvailability from '../StoreAvailability'

import * as S from './styles'

const PageLayout = ({ children }) => {
  const isHexaMenu =
    useFeatureToggle({
      splitName: 'hexa_menu_header',
    }) === FeatureToggle.ON

  return (
    <S.Layout>
      {isHexaMenu ? <HexaV2SideBarMenu /> : <SideBarMenu />}
      <S.LayoutMain isHexaMenu={isHexaMenu}>
        <S.LayoutContent>
          {!isHexaMenu && (
            <StoreAvailability pollingTime={STORE_AVAILABILITY_POLLING_TIME} />
          )}
          {children}
        </S.LayoutContent>
      </S.LayoutMain>
    </S.Layout>
  )
}

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isHexaMenu: PropTypes.bool,
}

export default PageLayout
